import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Spin2 } from "components";
import { Editor } from "components/fields";
import { toastAlert } from "@paylixecommerce/shared/components";
import { saveShopTermsSettings } from "./actions";
import { useFormik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
    terms_of_service: Yup.string().nullable(),
});

const Terms = ({ settings, setStep, skipStep }) => {
    const [loading, setLoading] = useState(false);
    const [initialValues, setInitialValue] = useState({ terms_of_service: '' });
    const dispatch = useDispatch();

    useEffect(() => {
        if (Object.keys(settings.shop).length) {
            let { terms_of_service } = settings.shop;
            setInitialValue({
                terms_of_service: terms_of_service || ""
            });
        }
    }, [Object.keys(settings.shop).length]);

    const onSubmit = (values) => {
        setLoading(true);
        dispatch(saveShopTermsSettings(values.terms_of_service))
            .then(setStep)
            .catch(res => toastAlert('error', res.error))
            .finally(() => setLoading(false));
    };

    let form = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema,
        onSubmit
    });

    return (
        <form onSubmit={form.handleSubmit}>
            <h4>Terms of Service</h4>

            <Editor name="terms_of_service" {...form} />

            <div className="setup-screen-step-buttons">
                <Button variant="secondary" size="large" type="button" onClick={skipStep}>
                    Skip Step
                </Button>
                <Button variant="primary" size="large" type="submit">
                    {loading ? <Spin2 /> : 'Next Step'}
                </Button>
            </div>
        </form>
    );
};

export default Terms;